import * as React from 'react';
import { WrapperDataModel } from '../../../models/wrapperDataModel';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faPlus, faMinus, faChartBar } from '@fortawesome/free-solid-svg-icons';
import * as HelperFunctions from '../../../common/helperFunctions';
import * as HelperComponent from '../../../common/components/helperComponent'
import { MainSceneInfoPanel, TagType } from '../../../common/enums';
import { TagModel } from '../../../models/tagModel';
import PieChartComponent from './pieChart.Component';
import Translate from '../../../common/translate';

const InfoPanelComponent = (props: any) => {
    const data: WrapperDataModel = props.data;
    const [isLabelOpen, setLabel] = React.useState(false);
    let label = <div></div>;

    label = <>
        <div style={{ display: 'flex', alignItems: 'center' }}>
            <div className="info-panel-title">
                {props.dataTypeId ? Translate(HelperFunctions.getEnumLabel(props.dataTypeId, MainSceneInfoPanel, true)) : ''}
            </div>
            {!props.isZoomIn ?
                <div className="info-panel-toggle" onClick={() => setLabel(!isLabelOpen)}
                    onTouchStartCapture={() => setLabel(!isLabelOpen)}>
                    <FontAwesomeIcon icon={isLabelOpen ? faMinus : faPlus} />
                </div>
                : null
            }
        </div>

        {(isLabelOpen || props.isZoomIn) ?
            <>
                {props.dataTypeId !== MainSceneInfoPanel.EnergyDistribution ?
                    <div className="info-panel-data">
                        {data && data.tagsData && data.tagsData.length > 0 ?
                            data.tagsData.map((r: TagModel, index: number) => {
                                return (
                                    <div key={r.tagType} className="info-panel-datarow">
                                        <div className="info-panel-datarow-icon-and-type">
                                            <div className="info-panel-datarow-icon">
                                                <FontAwesomeIcon icon={HelperFunctions.getTagIcon(r.tagType)} />
                                            </div>
                                            {r.tagType === TagType.VisitorsMonth || r.tagType === TagType.DayWithoutAccidents || r.tagType === TagType.Alarms ?
                                                <div className="info-panel-datarow-type link" onClick={() => props.clickOnPanel(r.tagType)}
                                                    onTouchStartCapture={() => props.clickOnPanel(r.tagType)}>
                                                    {Translate(HelperFunctions.getEnumLabel(r.tagType, TagType, true))}
                                                </div>
                                                : <div className="info-panel-datarow-type">
                                                    {Translate(HelperFunctions.getEnumLabel(r.tagType, TagType, true))}
                                                </div>}
                                            {r.tagType === TagType.VisitorsMonth || r.tagType === TagType.DayWithoutAccidents || r.tagType === TagType.Alarms ?
                                                <div className="info-panel-open-chart" onClick={() => props.clickOnPanel(r.tagType)}
                                                    onTouchStartCapture={() => props.clickOnPanel(r.tagType)}>
                                                    <FontAwesomeIcon icon={faChartBar} />
                                                </div> : null}
                                        </div>
                                        <div className="info-panel-datarow-value">
                                            <span style={{ paddingRight: 5 }}>{HelperComponent.getWarningIcon(r.tagType, r.value)}</span>
                                            <span className={props.isDataUpdated && r.isValueChanged ? 'blinker' : ''}>
                                                {r && r.value ? r.value + ' ' : getNotAvailableLabel(r.tagType)}
                                            </span>
                                            <span className="info-panel-datarow-value-unit">
                                                {r && r.value ? HelperComponent.getTagUnit(r.tagType) : getNotAvailableUnit(r.tagType)}
                                            </span>
                                        </div>
                                    </div>
                                )
                            })
                            : null}
                    </div>
                    : null}


                {props.dataTypeId === MainSceneInfoPanel.EnergyDistribution ?
                    <div className="info-panel-data">
                        <div className="pie-chart-container">
                            <div className="pie-legend-wrapper">
                                {data && data.tagsData ?
                                    <>
                                        <PieChartComponent data={data.tagsData} />
                                        <div className="flexbox-column">
                                            {data.tagsData.map((r: TagModel) => {
                                                return (
                                                    <div key={r.tagType + "legend"} className="legend-container">
                                                        <div className="legend-circle"
                                                            style={{ backgroundColor: HelperFunctions.getLegendColorByText(HelperFunctions.getEnumLabel(r.tagType, TagType, true)) }}></div>
                                                        <div className="legend-label">{HelperFunctions.getEnumLabel(r.tagType, TagType, true)}</div>
                                                        <div className="legend-value">
                                                            <span className={props.isDataUpdated && r.isValueChanged ? ' blinker' : ''}>{r.value}</span>
                                                            <span className="info-panel-datarow-value-unit"> %</span>
                                                        </div>
                                                    </div>)
                                            })}
                                        </div>
                                    </>
                                    : null}
                            </div>
                        </div>
                    </div>
                    : null}
            </> : null}
    </>

    return label;
}

const getNotAvailableLabel = (tagType: number) => {
    switch (tagType) {
        case TagType.WindSpeed:
            return '0 ';
        default:
            return 'N/A';
    }
}

const getNotAvailableUnit = (tagType: number) => {
    switch (tagType) {
        case TagType.WindSpeed:
            return 'm/s';
        default:
            return null;
    }
}

export default InfoPanelComponent